import React, { Component } from 'react';

import { withDomains, RESTExecutor } from '../../../lib/domain';
import { Row, Table, Button, Input } from 'antd';
import Title from 'antd/lib/typography/Title';
import { PopUpForm } from '../../../lib/ui/popupform';
import { formatMoney } from '../../../lib/util';


const batcher_cols = ({onEditPressed}) => [
    {
        title: "Batcher Name",
        dataIndex: "name",
        key: 'name'
    },
    {
        title: "ID",
        dataIndex: 'id',
        key: 'id'
    },
    // {
    //     title:"",
    //     dataIndex:'id',
    //     key:'action',
    //     render:(id,data)=><Button 
    //     type='link'
    //     onClick={()=>{
    //         typeof onEditPressed==='function'&&onEditPressed(data)
    //     }}>Edit</Button>

    // }
]

const batcher_fields = [
    {
        index: 'id',
        name: "Batcher ID",
        type: 'text',
        show_update:false
    },
    {
        index: 'name',
        name: "Batcher Name",
        type: 'text'
    },
    {
        index: 'validation_config',
        name: "Validation Config",
        type: 'json'
    }
]

class BatchersView extends Component {
    constructor(props) {
        super(props)

        this.state = {
            form_visibility: false,
            form_data: {},
            edit_id: null
        };

        this.list_batchers = RESTExecutor.list().config({
            label: 'batchers'
        }).connect(props.domains.settings);


        this.post_batchers = RESTExecutor.post().config({
            label: 'batchers',
            
        }).callbacks((success) => {
                this.list_batchers.execute();

                this.setState({
                    form_visibility: false,
                    form_data: {},
                    edit_id: null
                })
            })
            .connect(props.domains.settings);

        this.patch_batcher=RESTExecutor.patch().config({
            label:'batchers_detail'
        }).forId("").callbacks((success)=>{
            this.list_batchers.execute();

                this.setState({
                    form_visibility: false,
                    form_data: {},
                    edit_id: null
                })

        }).connect(props.domains.settings);

    };

    handlePostPatch=(data)=>{
        if(this.state.edit_id){
            this.patch_batcher.forId(this.state.edit_id).execute(data);
        }else{
            this.post_batchers.execute(data);
        }
    }

    render() {
        let list_batchers_res=this.list_batchers.response();
        let list_batchers_data=list_batchers_res.result||{};
        let post_batcher_resp = this.post_batchers.response();
        let patch_batcher_resp= this.patch_batcher.response();
        let rowsMeta=list_batchers_res.meta||{}

        let rowsData=list_batchers_data.rows||[];

        let filteredData=JSON.parse(JSON.stringify(rowsData));
        if(this.state.query){
            filteredData=filteredData.filter(({ name="",id="",description="" }) => {
                name = name.toLowerCase();
                id=id.toLowerCase();
                description=description.toLowerCase();
                return name.includes(this.state.query.toLowerCase())
                ||id.includes(this.state.query.toLowerCase())
                ||description.includes(this.state.query.toLowerCase())
                ;
            });
        }


        return (
            <div>
               
                <Table 
                scroll={{x:true}}
                loading={list_batchers_res.fetching}
                columns={batcher_cols({
                    onEditPressed:(data)=>{
                        this.setState({
                            form_visibility:true,
                            form_data:data,
                            edit_id:data.id
                        })
                    }
                })}
                pagination={{
                    showTotal:(total,range)=>`${formatMoney(range[0],0)}-${formatMoney(range[1],0)} of ${formatMoney(total,0)} items`
                    }}
                dataSource={filteredData}
                className='main-table'                size='small'
                // pagination={{
                //     simple: true,
                //     onChange: (current, size) => {
                //         this.list_batchers.config({
                //             params: {
                //                 per_page: size,
                //                 page: current
                //             }
                //         }).execute();
                //     },
                //     defaultCurrent: 1,
                //     current: rowsMeta.pagination && parseInt(rowsMeta.pagination.split('/')[0]),
                //     // defaultPageSize: 20,
                //     pageSize: (rowsMeta && rowsMeta.requested_count),

                //     total: (rowsMeta && rowsMeta.total_count),
                //     showTotal: (total, range) => `${formatMoney(range[0],0)}-${formatMoney(range[1],0)} of ${formatMoney(total,0)} items`
                // }}
                title={()=><div><Row type='flex' justify='space-between' style={{
                    alignItems:'center'
                  }}><Title 
                  type='secondary'
                  level={3}
                  
                  style={{
                    margin:0
                  }}>Batchers List</Title>
                  {/* <Button type='primary' onClick={() => {
                            this.setState({
                                edit_id: null,
                                form_data: {},
                                form_visibility: true
                            })
                        }}>Add New Batcher</Button> */}
                  </Row>
                  <br></br>
                    <Row type='flex'
                    justify='space-between'
                    style={{
                    alignItems: 'center',
                    flexWrap: 'nowrap'
                }}>
                        <Input.Search
                        autoFocus
                            placeholder="Search For"
                            style={{
                        }}
                            value={this.state.query}
                            onChange={(e) => {
                                this.setState({query:e.target.value})
                            }}
                           /> {this.state.query && this.state.query.length > 0 && <Button
                            style={{
                            marginLeft: 4
                        }}
                            type='danger'
                            shape="circle"
                            icon="close-circle"
                            onClick={() => {
                            this.setState({query:null})
                        }}/>}
                    </Row>

                  
                  </div>}
                  rowKey={(record)=>record.id}
                />
            </div>
        );
    }

    componentDidMount(){
        this.list_batchers.execute()
    }
}

export default withDomains(BatchersView,"settings");
